import { NgUserGridAlertConfig } from '../../models';
import { TransferHttpService } from '../services/transfer-http/transfer-http.service';

export class GridAlert {

  public constructor (public gridAlertHubId: string, private transferHttp: TransferHttpService) {
    this.getUserGridAlerts();
  }

  public isDailyChangesSubscribed: boolean;
  public isAllChangesSubscribed: boolean;

  public everyAlert() {
    this.transferHttp.put(`Alerts/SaveUserGridAllAlertConfig?gridAlertHubId=${this.gridAlertHubId}`, null).subscribe(_ => {
      this.getUserGridAlerts();
    });
  }

  public dailyAlert() {
    this.transferHttp.put(`Alerts/SaveUserGridDailyAlertConfig?gridAlertHubId=${this.gridAlertHubId}`, null).subscribe(_ => {
      this.getUserGridAlerts();
    });
  }

  public getUserGridAlerts() {
    this.transferHttp.get(`Alerts/GetUserGridAlertConfigByConfigId?gridAlertHubId=${this.gridAlertHubId}`).subscribe( {
      next: ret => {
      let config: NgUserGridAlertConfig = ret;
      this.isDailyChangesSubscribed = config?.dailyNotice ?? false;
      this.isAllChangesSubscribed = config?.allChangeNotice ?? false;
    },
    error: err => { console.log('Error: Getting Initial Grid Alert Subscriptions'); }
  });
  }
}
